import { Link } from 'react-router-dom'

interface NavLinkProps {
 link: string
}

export function NavLinkFooter({ link }: NavLinkProps) {
 const url =
  link === 'home'
   ? '/'
   : '/' + link.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

 return (
  <li className="text-right">
   <Link
    to={url}
    aria-label={`Ir para a página ${link}`}
    role="link"
    className="no-underline text-white font-bold font-['rns-milesblack'] text-base hover:text-[var(--primary-yellow)] uppercase"
   >
    {link}
   </Link>
  </li>
 )
}
